import { __awaiter, __generator } from "tslib";
import { wait } from '../../../../_shared/library/promise';
/**
 * This is an alternative to `setDelay`, but it actually executes the
 * function only when the source document is visible.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
 */
export function runDelayedWhenVisible(fn, delayInMillis) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    function executeVisible() {
        if (document.visibilityState === 'visible') {
            return fn.apply(void 0, args);
        }
    }
    return setDelay(executeVisible, delayInMillis);
}
/**
 * Executes given function with the interval of given milliseconds.
 * This may seem the same as the built-in function `setInterval` but
 * there is one important difference. If the given function is running
 * longer than given interval `setInterval` starts a new one anyway but
 * this function always waits for the function to finish before starting
 * the next one. This is quite common when the network is slow.
 */
function setDelay(fn, delayInMillis) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var isRunning = true;
    function polling() {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isRunning) return [3 /*break*/, 6];
                        return [4 /*yield*/, wait(delayInMillis)];
                    case 1:
                        _a.sent();
                        if (!isRunning) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, fn(args)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        console.error(e_1); // ignore failure and try again after delay
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 0];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    polling();
    return function () {
        isRunning = false;
    };
}
